import { Pipe, PipeTransform } from '@angular/core';
import { escape } from 'lodash-es';

@Pipe({ name: 'escapedHtml' })
export class EscapedHtmlPipe implements PipeTransform {
  transform(value: string, options?: any): string {
    return escape(value);
  }
}
